import { ref } from 'vue';
import { createCalculator } from '../calculator/calculatorCore';

/** Vue adapter over pure calculator core (also used by fuzz tests). */
export function useCalculator(scientific = false) {
  const core = createCalculator(scientific);
  const expression = ref(core.state.expression);
  const result = ref(core.state.result);
  const formulaLine = ref(core.state.formulaLine);
  const displayMain = ref(core.state.displayMain);
  const memory = ref(core.state.memory);
  const error = ref(core.state.error);

  function pull() {
    expression.value = core.state.expression;
    result.value = core.state.result;
    formulaLine.value = core.state.formulaLine;
    displayMain.value = core.state.displayMain;
    memory.value = core.state.memory;
    error.value = core.state.error;
  }

  function bind<T extends (...args: never[]) => void>(fn: T): T {
    return ((...args: Parameters<T>) => {
      fn(...args);
      pull();
    }) as T;
  }

  return {
    expression,
    result,
    formulaLine,
    displayMain,
    memory,
    error,
    append: bind(core.append),
    clearAll: bind(core.clearAll),
    clearEntry: bind(core.clearEntry),
    backspace: bind(core.backspace),
    toggleSign: bind(core.toggleSign),
    calculate: bind(core.calculate),
    applyPercent: bind(core.applyPercent),
    applySqrt: bind(core.applySqrt),
    applySquare: bind(core.applySquare),
    applyReciprocal: bind(core.applyReciprocal),
    applyFactorial: bind(core.applyFactorial),
    pressLog10: bind(core.pressLog10),
    pressLn: bind(core.pressLn),
    memClear: bind(core.memClear),
    memRecall: bind(core.memRecall),
    memAdd: bind(core.memAdd),
    memSub: bind(core.memSub),
    memStore: bind(core.memStore),
  };
}
